import React, { useState, useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import BasicModal from '../Dialog'
import {
  Autocomplete,
  Button,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'

interface Props {
  selectedGroups: any
  allUserGroups: any[]
  show: boolean
  size: any
  index: number
  onHide: () => void
  onUpdate: (e: any[], index: number) => void
}

const UserGroupModal = (props: Props) => {
  const { t } = useTranslation('translation')
  const [selectedGroups, setSelectedGroups] = useState([])
  useEffect(() => {
    setSelectedGroups(props.selectedGroups ? [...props.selectedGroups] : [])
  }, [props.selectedGroups])

  const chooseButtonGrouphandler = (e: any) => {
    setSelectedGroups([...e])
  }

  return (
    <BasicModal
      open={props.show}
      onClose={props.onHide}
      title={t('Answer Settings')}
      sx={{ p: 2 }}
    >
      <div className="tw-flex tw-items-center tw-gap-2 tw-my-4">
        <Typography variant="subtitle2">{t('User Group')}</Typography>
        <Tooltip
          title={t(
            'You can choose to assign this response to user groups. Only the users in the selected user groups will get this response for the question.',
          )}
        >
          <IconButton color="primary">
            <HelpOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </div>

      <Autocomplete
        size="small"
        multiple
        value={[...selectedGroups]}
        onChange={(_event: any, newValue) => {
          chooseButtonGrouphandler(newValue)
        }}
        options={[...props.allUserGroups]}
        renderInput={params => (
          <TextField {...params} placeholder={t('Select user group')} />
        )}
      />
      <div className="tw-flex tw-justify-end tw-gap-2 tw-mt-4">
        <Button
          variant="contained"
          onClick={e => props.onUpdate(selectedGroups, props.index)}
        >
          {t('Done')}
        </Button>
        <Button variant="outlined" onClick={props.onHide}>
          {t('Cancel')}
        </Button>
      </div>
    </BasicModal>
  )
}

export default UserGroupModal
